import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { LoadStatus } from '../../load-status';
import { MEASUREMENT_TOOLS_FEATURE_KEY, MeasurementToolsCollectionState } from '../measurement-tools-collection.state';
import { TimeUtilities } from '../../../utilities/time-utilities';

export const selectMeasurementToolsFeature =
    createFeatureSelector<MeasurementToolsCollectionState>(MEASUREMENT_TOOLS_FEATURE_KEY);

export const selectMeasurementTools = createSelector(selectMeasurementToolsFeature, (state) => state.tools);

export const selectCalibratedMeasurementTools = createSelector(selectMeasurementTools, (tools) => {
    return tools.filter((tool) => TimeUtilities.momentFromDateAndTime(tool.calibratedDate, '').isSameOrAfter());
});

export const selectMeasurementToolsStatus: MemoizedSelector<object, LoadStatus> = createSelector(
    selectMeasurementToolsFeature,
    (state) => state.status,
);

export const selectMeasurementToolsLoaded: MemoizedSelector<object, boolean> = createSelector(
    selectMeasurementToolsFeature,
    (state) => state.status === LoadStatus.Loaded,
);
